import type { ISerialize } from '@/objects/ISerialize';
import { ProductionTableDef } from './ProductionTableDef';

export class ProductionDeviceSetting implements ISerialize {
    public BackgroundColor: string | null = '#000000';

    public DeviceId: string;

    public DisplayType: string;

    public EventId: number;

    public FontSize: number = 150;

    public ForegroundColor: string | null = '#FFFFFF';

    public RowFadeooutPeriod: number = 3000;

    public RowFadeoutColor: string | null = '#00000000';

    public Tables: ProductionTableDef[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        BackgroundColor?: string | null;
        DeviceId?: string | null;
        DisplayType?: string | null;
        EventId?: number;
        FontSize?: number;
        ForegroundColor?: string | null;
        RowFadeooutPeriod?: number;
        RowFadeoutColor?: string | null;
        Tables?: ProductionTableDef[];
    }) {
        this.BackgroundColor = values.BackgroundColor ?? '#000000';

        this.DeviceId = values.DeviceId ?? '';

        this.DisplayType = values.DisplayType ?? '';

        this.EventId = values.EventId ?? 0;

        this.FontSize = values.FontSize ?? 150;

        this.ForegroundColor = values.ForegroundColor ?? '#FFFFFF';

        this.RowFadeooutPeriod = values.RowFadeooutPeriod ?? 3000;

        this.RowFadeoutColor = values.RowFadeoutColor ?? '#00000000';

        this.Tables = values.Tables ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"BackgroundColor": ${JSON.stringify(this.BackgroundColor)}` +
            ',' +
            `"DeviceId": ${JSON.stringify(this.DeviceId)}` +
            ',' +
            `"DisplayType": ${JSON.stringify(this.DisplayType)}` +
            ',' +
            `"EventId": ${JSON.stringify(this.EventId)}` +
            ',' +
            `"FontSize": ${JSON.stringify(this.FontSize)}` +
            ',' +
            `"ForegroundColor": ${JSON.stringify(this.ForegroundColor)}` +
            ',' +
            `"RowFadeooutPeriod": ${JSON.stringify(this.RowFadeooutPeriod)}` +
            ',' +
            `"RowFadeoutColor": ${JSON.stringify(this.RowFadeoutColor)}` +
            ',' +
            `"Tables": [ ${this.Tables.map((x) => (!x ? null : x?.serialize()))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of ProductionDeviceSetting from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        BackgroundColor?: string | null;
        DeviceId?: string | null;
        DisplayType?: string | null;
        EventId?: number;
        FontSize?: number;
        ForegroundColor?: string | null;
        RowFadeooutPeriod?: number;
        RowFadeoutColor?: string | null;
        Tables?: ProductionTableDef[];
    }): ProductionDeviceSetting {
        return new ProductionDeviceSetting(values);
    }

    public static _FromServerJson(json: any): ProductionDeviceSetting {
        return new ProductionDeviceSetting({
            BackgroundColor: json.BackgroundColor ?? '',
            DeviceId: json.DeviceId ?? '',
            DisplayType: json.DisplayType ?? '',
            EventId: json.EventId,
            FontSize: json.FontSize,
            ForegroundColor: json.ForegroundColor ?? '',
            RowFadeooutPeriod: json.RowFadeooutPeriod,
            RowFadeoutColor: json.RowFadeoutColor ?? '',
            Tables: json.Tables?.map((x: any) => ProductionTableDef._FromServerJson(x)),
        });
    }

    /**
     * Creates an instance of ProductionDeviceSetting from another instance of ProductionDeviceSetting.
     * @param other The ProductionDeviceSetting you want to clone
     * @returns A cloned ProductionDeviceSetting
     */
    public static FromOther(other: ProductionDeviceSetting): ProductionDeviceSetting {
        return ProductionDeviceSetting._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ProductionDeviceSetting.FromOther(this);
    }

    static NAME_OF_CLASS = 'ProductionDeviceSetting';
}
